import InfoIcon from '../assets/icons/info-icon.svg'

export const userLimitReachedHtml = `<div style="display: flex; justify-content: center; align-items: center;">
                <img src=${InfoIcon} width="100px" height="100px" style="margin-right: 8px;" /></div>
                <p>This one is for users: Your firm has used all of the available users per its current plan.  Your administrator can add additional users or upgrade the subscription plan.</p>`

export const caseLimitReachedHtml = `<div style="display: flex; justify-content: center; align-items: center;">
    <img src=${InfoIcon} width="100px" height="100px" style="margin-right: 8px;" />         
  </div>
            <p>Your firm users have generated all of the demands available for the month through its current monthly subscription. Don't worry, you can continue to generate demands this month and will be charged at the same rate per demand. The administrator for your firm can also upgrade your subscription plan.</p>`

export const templateEditorDeafultFontFamily = 'monospace'

export const fontFamilyOptions = [
  { key: "times-new-roman", value: "Times New Roman", text: "Times New Roman" },
  { key: "sans-serif", value: "Arial", text: "Sans Serif" },
  { key: "serif", value: "Times New Roman", text: "Serif" },
  { key: "monospace", value: "Courier New", text: "Monospace" },
  { key: "arial", value: "Arial", text: "Arial" },
  { key: "Poppins", value: "Poppins", text: "Poppins" },
  { key: "georgia", value: "Georgia", text: "Georgia" },
  { key: "garamond", value: "Garamond", text: "Garamond"}
]

export const fontSizeOptions = [
  { key: "8px", value: "8", text: "8px" },
  { key: "9px", value: "9", text: "9px" },
  { key: "10px", value: "10", text: "10px" },
  { key: "11px", value: "11", text: "11px" },
  { key: "12px", value: "12", text: "12px" },
  { key: "13px", value: "13", text: "13px" },
  { key: "14px", value: "14", text: "14px" },
  { key: "15px", value: "15", text: "15px" },
  { key: "16px", value: "16", text: "16px" },
  { key: "17px", value: "17", text: "17px" },
  { key: "18px", value: "18", text: "18px" },
  { key: "19px", value: "19", text: "19px" },
  { key: "20px", value: "20", text: "20px" },
  { key: "21px", value: "21", text: "21px" },
  { key: "22px", value: "22", text: "22px" },
  { key: "23px", value: "23", text: "23px" },
  { key: "24px", value: "24", text: "24px" },
  { key: "25px", value: "25", text: "25px" },
  { key: "26px", value: "26", text: "26px" },
  { key: "27px", value: "27", text: "27px" },
  { key: "28px", value: "28", text: "28px" },
  { key: "29px", value: "29", text: "29px" },
  { key: "30px", value: "30", text: "30px" },
  { key: "31px", value: "31", text: "31px" },
  { key: "32px", value: "32", text: "32px" }
];

export const DefaultMultiPlaintiffName = {
  DEFAULT_PLAINTIFF_Name: "",
  DEFAULT_DEFENDANT_Name: ""
}

export const ChatbotSuggestions = [
  "What are the strengths and weaknesses of the case?",
  "Provide a brief summary of the patients medical visit dates in this case",
  [
    "Can you determine if any providers were mentioned in the medical records that were not included with the case?",
    "Please show the differences in prior medical complaints compared to post accident medical complaints",
    "Was there mention of TBI in the case?"
  ]
];

export const partnerListColor = {
  "Chart Squad": "var(--color-white)",
  "Google Cloud": "#28d294",
  "Amazon Web Services": "#1ab4d9",
  "Microsoft Azure": "#1671c5",
};


export const badStatusFileError = `This file cannot be processed. Please check the format.`;

export const fileUploadError = `Error uploading file(s)`;


export const fileUploadingBtnToolTipMsg = `File is uploading. Please wait...`;
export const missingPlaintiffFilesTooltipMsg = `Upload at least one file for each plaintiff before finalizing`;
export const badRecordBtnToolTipMsg = <>A file could not be processed. <br/> Please review uploads.</>;


export const finalizePlanBtnLabel = {
  submitting: 'Finalizing...',
  reFinalize: 'Re-Finalize Plan',
  finalize: 'Finalize Plan',
};

export const liabilityFilesKey = ["policeReportData","incidentReports","expertSafetyReport","witnessStatements","accidentSceneFiles","productImageFiles"];

export const DELETE_CONFIRMATION_TEXT = {
  plaintiff: {
    title: 'Delete plaintiff?',
    message: (name) =>
      `Deleting ${name || 'this plaintiff'} will permanently remove all of their medical records, pain & suffering files, and economic damages files from the case. This action cannot be undone.`,
  },
  defendant: {
    title: 'Delete defendant?',
    message: (name) =>
      `Deleting ${name || 'this defendant'} will permanently remove all of their liability files (witness statements, incident reports, police reports, accident scene files, expert safety reports) from the case. This action cannot be undone.`,
  },
};
export const CASE_ROUTE_PATTERNS = [
  "/case/summary/:caseId",
  "/case/edit/:caseId",
  "/case/:caseId/demand-studio",
  "/case/finalize/:caseId",
  "/embed/case/edit/:caseId",
];

